import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./pages/components/Navbar";
import Login from "./pages/Login";
import Experiments from "./pages/Experiments";
import ExperimentView from "./pages/ExperimentView";
import PartChartsView from './pages/PartChartsView';
import CreateExperiment from "./pages/CreateExperiment";
import EditExperiment from "./pages/EditExperiment";
import EditSettings from "./pages/EditSettings";
import SendUserInvite from "./pages/SendUserInvite";
import ShareExperiment from "./pages/ShareExperiment";
import SharedExperimentsView from "./pages/SharedExperimentsView";
import RegisterUser from "./pages/RegisterUser";
import ErrorNoPage from "./pages/ErrorNoPage";

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
           jwtToken: null,
           userMail: null,
           isAdmin: null
        };
        if ( window.sessionStorage.getItem("jwtToken") !== null ){
            this.state.jwtToken = window.sessionStorage.getItem("jwtToken");
        }
        if ( window.sessionStorage.getItem("userMail") !== null ){
            this.state.userMail = window.sessionStorage.getItem("userMail");
        }
        if ( window.sessionStorage.getItem("isAdmin") !== null ){
            this.state.isAdmin = window.sessionStorage.getItem("isAdmin");
        }

        this.handleUpdate = this.handleUpdate.bind(this);
    }

    handleUpdate = (responseToken, mail, admin) => {
       this.setState({
         jwtToken: responseToken,
         userMail: mail,
         isAdmin: admin
       });
    }

    render() {
        if (this.state.jwtToken === null) {
            return (
                <BrowserRouter>
                    <Routes>
                        <Route index element={<Login handleLogin={this.handleUpdate}/>} />
                        <Route path="/user/invite/:uuid" element={<RegisterUser />} />}/>
                        <Route path="*" element={<Login handleLogin={this.handleUpdate}/>} />
                    </Routes>
                </BrowserRouter>
            );
        }
        return(
            <BrowserRouter>
                <Routes>
                  <Route path="/" element={<Navbar isAdmin={this.state.isAdmin} loggedIn={true} handleLogout={this.handleUpdate} userMail={this.state.userMail}/>}>
                    <Route index element={<Experiments jwtToken={this.state.jwtToken}/>} />
                    <Route path="/settings" element={<EditSettings jwtToken={this.state.jwtToken} mail={this.state.userMail} handleLogout={this.handleUpdate}/>}/>
                    <Route path="/new" element={<CreateExperiment jwtToken={this.state.jwtToken}/>} />
                    <Route path="/shared" element={<SharedExperimentsView jwtToken={this.state.jwtToken}/>} />
                    <Route path="/edit/:id" element={<EditExperiment jwtToken={this.state.jwtToken}/>} />
                    <Route path="/share/:id" element={<ShareExperiment jwtToken={this.state.jwtToken}/>} />
                    <Route path="/detail/:id" element={<ExperimentView jwtToken={this.state.jwtToken}/>} />
                    <Route path="/detail/part/:id" element={<PartChartsView jwtToken={this.state.jwtToken}/>} />
                    <Route path="/admin/invite" element={<SendUserInvite jwtToken={this.state.jwtToken}/>} />}/>
                    <Route path="*" element={<ErrorNoPage />} />
                  </Route>
                </Routes>
            </BrowserRouter>
        );
    }
}

export default App;
